import { FILTER_SHOW_ALL } from '@constants/Notifications'
import { REPORTS_DEFAULT_FILTERS } from '@constants/Reports/reportsDefaultToolbar.constants'
import {
  AtRiskAgeBucket,
  AtRiskLevelFilter,
  ReportsDistributionView,
  ReportsRangeTab,
  ReportsTabOption,
} from '@dataTypes/reports.type'

export const REPORTS_RANGE_TABS: ReportsTabOption<ReportsRangeTab>[] = [
  { label: '1D', value: '1D' },
  { label: '1W', value: '1W' },
  { label: '1M', value: '1M' },
  { label: '1Y', value: '1Y' },
  { label: 'YTD', value: 'YTD' },
  { label: 'Growth', value: 'Growth' },
]

export const REPORTS_DISTRIBUTION_RANGE_TABS: ReportsTabOption<
  Exclude<ReportsRangeTab, 'Growth'>
>[] = REPORTS_RANGE_TABS.filter(
  (tab): tab is ReportsTabOption<Exclude<ReportsRangeTab, 'Growth'>> =>
    tab.value !== 'Growth',
)

export const REPORTS_PATIENT_TREND_RANGE_TABS: ReportsTabOption<
  Exclude<ReportsRangeTab, 'Growth'>
>[] = REPORTS_DISTRIBUTION_RANGE_TABS

export const REPORTS_DISTRIBUTION_VIEW_TABS: ReportsTabOption<ReportsDistributionView>[] =
  [
    { label: 'Count', value: 'Count' },
    { label: 'Percentage', value: 'Percentage' },
  ]

export const AT_RISK_LEVEL_FILTER_TABS: ReportsTabOption<AtRiskLevelFilter>[] =
  [
    { label: 'All', value: 'all' },
    { label: 'High', value: 'high' },
    { label: 'Medium', value: 'medium' },
    { label: 'Low', value: 'low' },
  ]

/** Full-view table SearchWithFilter: risk level options match {@link RiskPatientRow.riskLevel} values. */
export const AT_RISK_TABLE_FULL_VIEW_SEARCH_FILTERS: Record<string, string[]> =
  {
    riskLevel: [FILTER_SHOW_ALL, 'High', 'Medium', 'Low'],
  }

export const PATIENT_BASE_HEALTH_FILTERS = REPORTS_DEFAULT_FILTERS

export const PATIENT_BASE_HEALTH_KPI_DEFINITIONS: Array<{
  id: string
  title: string
  footer: string
  format: 'count' | 'signedCount' | 'percent'
  unitInline?: string
  valueTone?: 'danger'
  footerMode?:
    | 'percentChange'
    | 'pointChange'
    | 'percentOfPriorBase'
    | 'descriptor'
}> = [
  {
    id: 'total-active-patients',
    title: 'Total active patients',
    footer: '',
    format: 'count',
    unitInline: 'patients',
    footerMode: 'percentChange',
  },
  {
    id: 'net-active-growth',
    title: 'Net active growth',
    footer: '',
    format: 'signedCount',
    footerMode: 'percentOfPriorBase',
  },
  {
    id: 'retention-rate',
    title: 'Retention rate',
    footer: '',
    format: 'percent',
    footerMode: 'pointChange',
  },
  {
    id: 'reactivation-rate',
    title: 'Reactivation rate',
    footer: '',
    format: 'percent',
    footerMode: 'pointChange',
  },
  {
    id: 'at-risk-patient',
    title: 'At-Risk patients',
    footer: '',
    format: 'count',
    unitInline: 'patients',
    valueTone: 'danger',
    footerMode: 'percentChange',
  },
]

export const AT_RISK_AGE_BUCKET_META: Array<
  Pick<AtRiskAgeBucket, 'id' | 'label' | 'color'>
> = [
  {
    id: 'age-0-17',
    label: '0-17 Yrs',
    color: 'var(--blue-700)',
  },
  {
    id: 'age-18-34',
    label: '18-34 Yrs',
    color: 'var(--blue-600)',
  },
  {
    id: 'age-35-54',
    label: '35-54 Yrs',
    color: 'var(--blue-500)',
  },
  {
    id: 'age-55-plus',
    label: '55+',
    color: 'var(--blue-300)',
  },
]

/** Card (non-full) view row cap for At-risk patients table. */
export const AT_RISK_CARD_ROW_LIMIT = 7
